import { api } from './client'
import type {
  CreateJobRequest,
  Job,
  QuantityItem,
  SheetPngStatus,
  SpaceBill,
  UUID,
} from '@/types/api'

export const jobsApi = {
  create: async (projectId: UUID, body: CreateJobRequest): Promise<Job> =>
    (await api.post(`/projects/${projectId}/jobs`, body)).data,

  list: async (projectId: UUID): Promise<Job[]> =>
    (await api.get(`/projects/${projectId}/jobs`)).data,

  get: async (jobId: UUID): Promise<Job> => (await api.get(`/jobs/${jobId}`)).data,

  cancel: async (jobId: UUID): Promise<Job> =>
    (await api.post(`/jobs/${jobId}/cancel`)).data,

  cancelInFlight: async (projectId: UUID): Promise<Job[]> =>
    (await api.post(`/projects/${projectId}/jobs:cancel-in-flight`)).data,

  reviewComplete: async (jobId: UUID): Promise<Job> =>
    (await api.post(`/jobs/${jobId}/review:complete`)).data,

  quantities: async (jobId: UUID): Promise<QuantityItem[]> =>
    (await api.get(`/jobs/${jobId}/quantities`)).data,

  spaceBill: async (jobId: UUID): Promise<SpaceBill> =>
    (await api.get(`/jobs/${jobId}/space-bill`)).data,

  sheetPngStatus: async (jobId: UUID): Promise<SheetPngStatus> =>
    (await api.get(`/jobs/${jobId}/sheet-png-status`)).data,

  sheetPreviews: async (jobId: UUID, sheetNos: string[]): Promise<SheetPngStatus> =>
    (
      await api.get(`/jobs/${jobId}/sheet-previews`, {
        params: { sheet_nos: sheetNos.join(',') },
      })
    ).data,

  retrySheetPng: async (jobId: UUID): Promise<SheetPngStatus> =>
    (await api.post(`/jobs/${jobId}/sheet-png:retry`)).data,
}
